import { Observable } from 'rxjs';

import { BaseLiveSportsModel } from './live-event-list.service';

export enum LiveDispatcherEvents {
    ChildViewDataUpdate = 'CHILD_VIEW_DATA_UPDATE',
}

export interface ILiveDispatcher {
    on(event: LiveDispatcherEvents.ChildViewDataUpdate): Observable<BaseLiveSportsModel>;

    dispatch(event: LiveDispatcherEvents.ChildViewDataUpdate, data: BaseLiveSportsModel): void;
}
